<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card :v-if="!$apollo.loading">
          <v-card-title> Coaching</v-card-title>
          <div v-if="!activeSubscription">
            <v-card-text>
              No active subscription
            </v-card-text>
          </div>
          <template v-else>
            <div>
              <v-card-text>
                <h4>Product:</h4>
                <p>{{ activeSubscription.product.name }}</p>
                <h4>Coach:</h4>
                <p>
                  {{ activeSubscription.coach && activeSubscription.coach.firstName }}
                  {{ activeSubscription.coach && activeSubscription.coach.lastName }}
                </p>
                <h4>Nutrition Plan:</h4>
                <p>
                  {{
                    activeSubscription.user.userProfile.nutritionPlan &&
                      activeSubscription.user.userProfile.nutritionPlan.name
                  }}
                  <br />
                  {{
                    activeSubscription.user.userProfile.coachingNutritionPlan &&
                      `${activeSubscription.user.userProfile.coachingNutritionPlan.dietaryRestriction} ${activeSubscription.user.userProfile.coachingNutritionPlan.servingSize}`
                  }}
                </p>
              </v-card-text>
              <v-card-actions v-if="activeSubscription.coach">
                <v-spacer></v-spacer>
                <v-btn :to="'/client-profile/' + activeSubscription.coach.id + '/' + userId" color="secondary">
                  View coaching profile
                </v-btn>
              </v-card-actions>
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { COACHING_CLIENT_ACTIVE_SUBSCRIPTION_QUERY } from "@/constants/graphql/user_program/user_program";

export default {
  name: "ClientCoachInformation",
  props: ["userId"],
  data() {
    return {
      activeSubscription: null,
    };
  },
  apollo: {
    activeSubscription: {
      query: COACHING_CLIENT_ACTIVE_SUBSCRIPTION_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
    },
  },
};
</script>
